export function requestPendingSeasonEndCheck() {
  if (typeof window === 'undefined') {
    throw new Error('requestPendingSeasonEndCheck requires window');
  }
  window.dispatchEvent(new CustomEvent('coda-check-pending-season-end'));
}
